

























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation, namespace } from 'vuex-class';

import * as _ from 'lodash';

import TableForm from './components/TableForm.vue';

const fieldLabels: any = {
  name: '仓库名',
  url: '仓库域名',
  owner: '仓库管理员',
  approver: '审批人',
  dateRange: '生效日期',
  type: '仓库类型',
  name2: '任务名',
  url2: '任务描述',
  owner2: '执行人',
  approver2: '责任人',
  dateRange2: '生效日期',
  type2: '任务类型',
};

@Component({
  components: {
    TableForm,
  },
})
export default class AdvancedForm extends Vue {
  private tableData: any[] = [
    {
      key: '1',
      workId: '00001',
      name: 'John Brown',
      department: 'New York No. 1 Lake Park',
    },
    {
      key: '2',
      workId: '00002',
      name: 'Jim Green',
      department: 'London No. 1 Lake Park',
    },
    {
      key: '3',
      workId: '00003',
      name: 'Joe Black',
      department: 'Sidney No. 1 Lake Park',
    },
  ];

  private form: any = null;

  private errorCount: number = 0;
  private errors: any[] = [];

  constructor() {
    super();
  }

  private handlerFormCreate(form: any) {
    this.form = form;
  }

  private validate(e: any) {
    e.preventDefault();

    this.form.validateFieldsAndScroll((err: any, values: any) => {
      if (err) {
        this.formError();
      }
    });
  }

  private formError() {
    if (this.form == null) {
      return;
    }
    const errors = this.form.getFieldsError();
    this.errors = Object.keys(errors)
      .map((key: any) => {
        if (!errors[key]) {
          return;
        }
        const message = errors[key][0];
        const label = fieldLabels[key];
        return {
          [key]: key,
          msg: message,
          [label]: label,
        };
      })
      .filter((item: any) => item != null);

    const errorCount = Object.keys(errors).filter((key: any) => errors[key])
      .length;
    this.errorCount = errorCount;
  }

  private scrollToField(fieldKey: any) {
    const labelNode = document.querySelector(`label[for='${fieldKey}']`);
    if (labelNode) {
      labelNode.scrollIntoView(true);
    }
  }
}
